import { Card, Checkbox, Spin, Tooltip } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { ReactElement } from 'react';

interface GeneralSettingsProps {
  access: boolean;
  automaticallyImportData: boolean;
  isFetchingSource: boolean;
  isSaving: boolean;
  toggleAutomaticallyImportData: (e: CheckboxChangeEvent) => void;
}

const GeneralSettings = ({
  access,
  automaticallyImportData,
  isFetchingSource,
  isSaving,
  toggleAutomaticallyImportData,
}: GeneralSettingsProps): ReactElement => {
  return (
    <Card title="General Settings" style={{ width: '400px' }}>
      <Tooltip
        title={access ? 'Automatically Import Data' : 'You do not have the right permissions to automatically import data'}
      >
        <Checkbox
          disabled={!access || isFetchingSource || isSaving}
          checked={automaticallyImportData}
          onChange={toggleAutomaticallyImportData}
          data-test-id="automaticallyImportData-checkbox"
        >
          Automatically Import Data
        </Checkbox>
      </Tooltip>
      {isSaving && <Spin size="small" style={{ marginLeft: 10 }} />}
    </Card>
  );
};

export default GeneralSettings;
